export const PAGINATION_QUERY_PAYLOAD = {
  page: 0,
  size: 0,
  searchFilters: [
    {
      columnName: "string",
      columnValue: {},
      operation: "GREATER_THEN",
    },
  ],
  sortRules: [
    {
      columnName: "string",
      operation: "ASC",
    },
  ],
};
